import { deleteCompany } from 'commons/service/bank/company'
import { WriteHook, useMutationManager } from 'state-manager'

export const useDeleteCompany: WriteHook<number, void> = (opts) => useMutationManager(deleteCompany, opts)
